import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { PengeinstitutHistorik } from '@features/pengeinstitutter/pi-historik/pi-historik.model';

@Injectable({
  providedIn: 'root',
})
export class PiHistorikDatasource extends RestDatasource<PengeinstitutHistorik> {
  override endpoint = '/api/admin/pengeinstituthistorik';

  pengeinstitutId = signal<number | undefined>(undefined);
  data = resource({
    params: () => this.pengeinstitutId(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify({
            pengeinstitutId: params,
          }),
          sortBy: 'tidspunkt',
          descending: true,
        },
        abortSignal
      );
    },
  });
}
